import React, { FunctionComponent, useState } from 'react';
import YouTube from 'react-youtube';
import styles from './youtube-video.module.scss';

export interface IYoutubeVideoProps {
  videoId: string;
  title: string;
  episode: string;
  length: string;
  videoCover: {
    url: string;
    description: string;
  };
}

const opts = {
  height: '150',
  width: '280',
  playerVars: {
    autoplay: 1
  }
};

export const YoutubeVideo: FunctionComponent<IYoutubeVideoProps> = ({
  videoId,
  title,
  episode,
  length,
  videoCover
}) => {
  const [playVideo, setPlayVideo] = useState(false);
  const onReady = (event): void => {
    event.target.playVideo();
  };

  const playVideoHandler = (event): void => {
    setPlayVideo(true);
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.videoCover} onClick={playVideoHandler}>
        {!playVideo ? (
          <div className={styles.imageWrapper}>
            <img className={styles.coverImage} src={videoCover.url} alt="" />
            <div className={styles.playIcon}>
              <i className={'material-icons md-40 md-secondary-text'}>
                play_arrow
              </i>
            </div>
          </div>
        ) : (
          <YouTube videoId={videoId} opts={opts} onReady={onReady} />
        )}
      </div>
      <div className={styles.videoInfo}>
        <h3 className={styles.title}>{title}</h3>
        <div className={styles.extrainfo}>
          <span>{episode}</span>
          <span>{length}</span>
        </div>
      </div>
    </div>
  );
};
